/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_Evening_BeforeInputs */

const en_notify_evening_before = /** @type {(inputs: Notify_Evening_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The evening before`)
};

const de_notify_evening_before = /** @type {(inputs: Notify_Evening_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Vorabend`)
};

/**
* | output |
* | --- |
* | "The evening before" |
*
* @param {Notify_Evening_BeforeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_evening_before = /** @type {((inputs?: Notify_Evening_BeforeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_Evening_BeforeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_evening_before(inputs)
	return en_notify_evening_before(inputs)
});